// Branded dark hero texture — no photography. Shared by all page heroes.
export default function HeroBackdrop() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      <div className="absolute inset-0 grid-dots opacity-50" />
      <div className="absolute -top-40 right-[-8%] h-[480px] w-[480px] rounded-full bg-amber-400/[0.08] blur-3xl" />
      <div className="absolute bottom-[-35%] left-[-12%] h-[360px] w-[360px] rounded-full bg-amber-400/[0.04] blur-3xl" />
      <div className="absolute right-[6%] top-0 hidden h-full w-px bg-gradient-to-b from-transparent via-amber-400/25 to-transparent lg:block" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-amber-400/40 to-transparent" />
    </div>
  );
}
